import React from 'react'
import styled from '@emotion/styled'
import { color, space, shadow } from '@ticketswap/solar'
import { Envelope, Checkmark } from '@ticketswap/comets'

const IconContainer = styled.div`
  position: relative;
  color: ${color.earth};
  background-color: ${color.earthLightest};
  width: ${space[96]};
  height: ${space[96]};
  border-radius: ${space[48]};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Adornment = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: ${color.nova};
  box-shadow: ${shadow.strong};
  width: ${space[32]};
  height: ${space[32]};
  border-radius: ${space[32]};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.titan};
`

const EmailSent = () => (
  <IconContainer>
    <Envelope size={64} />
    <Adornment>
      <Checkmark size={24} />
    </Adornment>
  </IconContainer>
)

export default EmailSent
